import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserReportsService {
  private static reportList: Array<any> | undefined

  public get Reports(): Array<any> {
    return UserReportsService.reportList ?? []
  }

  constructor() {
    UserReportsService.reportList = UserReportsService.reportList ?? this.createDemoList()
  }

  private createDemoList(): Array<any> {
    return [
      this.createReport("Employees By Region", "1", "3c7606da-d190-47e4-a3eb-9a7e27a9caf9", "2fbf1c13-ec8f-45fd-82b8-ae65bf309d80", "c126dfff-331c-43be-a2f1-9e2423c33f0d"),
      this.createReport(
        "Separation By Function", 
        "2", 
        "3c7606da-d190-47e4-a3eb-9a7e27a9caf9", 
        "2fbf1c13-ec8f-45fd-82b8-ae65bf309d80", 
        "38db49dd-0969-48b8-9289-23493a86736d"
      ),
      this.createReport(
        "Min Max Telemetry",
        "3",
        "dfaaf478-0be8-4770-b2e5-c1e80fd04414",
        "512068ec-bfba-4865-8b3c-9a3feb621109",
        "00026f30-c6fd-47f7-a0de-a6cf977690c9"
      )
    ]
  }

  private createReport(name: string, id: string, dashboardId: string, sheetId: string, visualId: string) {
    return {
      displayName: name,
      id: id,
      dashboardId: dashboardId,
      sheetId: sheetId,
      visualId: visualId
    }
  }
}
